// extracted by mini-css-extract-plugin
module.exports = {"footer":"TripCartPanelPriceDetails_footer__HjQYz","root":"TripCartPanelPriceDetails_root__LdrRW","captainFeeInfo":"TripCartPanelPriceDetails_captainFeeInfo__b61E0"};